const _excluded = ["collapsed", "index"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from '@adsk/alloy-react-content-loader';
const widths = [113, 53, 88, 60, 130, 61, 124, 112, 124, 118];
const SideNavigationItemLoader = _ref => {
  let {
      collapsed,
      index
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ContentLoader, _extends({
    width: collapsed ? 24 : 196,
    height: 24
  }, props), !collapsed && /*#__PURE__*/React.createElement("rect", {
    x: "36",
    y: "8",
    rx: "4",
    ry: "4",
    width: widths[index % widths.length],
    height: "8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    rx: "12",
    ry: "12",
    width: "24",
    height: "24"
  }));
};
SideNavigationItemLoader.displayName = 'SideNavigationItemLoader';
SideNavigationItemLoader.propTypes = {
  collapsed: PropTypes.bool,
  /** The index of the loader, used to decide the width */
  index: PropTypes.number.isRequired
};
export default SideNavigationItemLoader;
//# sourceMappingURL=SideNavigationItemLoader.js.map